export function trans(key: string, lang: string) {
  // import translations for required lang from /locales folder and return the translation. if the key is not found, return en version
  const translations = require(`../locales/${lang}/messages.js`).messages
  return translations[key] || require(`../locales/en/messages.js`).messages[key]
}
